module.exports = __webpack_public_path__ + "media/site_templates/www.cabinetmaker.company/images/splash-0cb7ba7e2a2b4916cfd7152fa1c89cf9.jpg";